<script lang="ts" setup>
const props = defineProps<{ date: string }>()

const { locale } = useI18n()

const language = computed(() => locale.value == 'da' ? 'da-DK' : 'en-GB')

const formattedDate = computed(() => {
  try {
    return new Intl.DateTimeFormat(language.value, {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }).format(new Date(props.date))
  } catch (error) {
    return ''
  }
})
</script>

<template>
  <span class="uppercase">{{ formattedDate }}</span>
</template>
